<template>
  <v-container class="dark-login min-h-screen px-4">
    <row class="logo position-relative bg-primary">
      <a href="/" class="d-block text-decoration-none position-relative">
        <img src="@/assets/images/logos/LOGO-1.png" alt="logo-icon" class="logo-icon" max-width="60" width="45" height="auto" />
        <span class="logo-text fw-bold text-dark">MERO PRINTS</span>
      </a>
      <button
        class="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
        id="sidebar-burger-menu" @click="stateStoreInstance.onChange">
        <i data-feather="x"></i>
      </button>
    </row>
    <v-row class="w-100 h-100 align-center justify-space-between  mt-4">
      <v-col cols="12" md="6" class="d-none d-md-flex align-center justify-center image-container">
        <div class="overlay">
          <img :src="logo" alt="Mero Prints" class="img-fluid login-image" />
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-center align-center">
        <v-card class="pa-6 elevation-5 form-container" tile>
          <v-card-title class="text-center text-primary text-h5 font-weight-bold">
            Welcome Back!
          </v-card-title>
          <v-card-subtitle class="text-center text-grey-darken-1">
            Log in to continue
          </v-card-subtitle>
          <v-form @submit.prevent="handleLogin" class="mt-4">
            <v-text-field v-model="phone" label="Phone Number" type="tel" required class="mb-4" prepend-icon="mdi-phone"
              :rules="[(v) => !!v || 'Phone number is required']">
            </v-text-field>
            <v-text-field v-model="password" label="Password" :type="showPassword ? 'text' : 'password'" required
              class="mb-4" prepend-icon="mdi-lock" :rules="[(v) => !!v || 'Password is required']"
              :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append-inner="togglePassword">
            </v-text-field>
            <v-btn type="submit" color="primary" block class="mb-4" :loading="loading" :disabled="loading">
              Login
            </v-btn>
          </v-form>
          <p class="text-center">
            Don't have an account?
            <router-link to="/authentication/register" class="text-primary font-weight-bold">Sign up</router-link>
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import logo from "@/assets/images/logos/LOGO-1.png";
import Swal from "sweetalert2";
import { login } from "@/services/apiServices";
import { useTheme } from "@/composables/useThemes";
const { isDarkTheme } = useTheme();
const phone = ref("");
const password = ref("");
const loading = ref(false);
const showPassword = ref(false);
const router = useRouter();
const otpError = ref(false);

const handleLogin = async () => {
  try {
    loading.value = true;
    const token = await login(phone.value, password.value);

    if (!token) {
      throw new Error("Invalid credentials");
    }
    // Show success message
    Swal.fire({
      icon: "success",
      title: "Login Successful",
      text: "You have successfully logged in.",
      confirmButtonColor: "#4CAF50",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
       background: isDarkTheme.value ? "#333" : "#fff",
      // color: isDarkTheme.value ? "#fff" : "#000",
      iconColor: isDarkTheme.value ? "#0f0" : "#28a745",
      timer: 3000,
      timerProgressBar: true,
    });
    router.push("/dashboard");
  } catch (error) {
    const errorData = error.response?.data;
    // console.log(errorData);
    // Check if the error message requires OTP verification
    if (errorData?.otp_verified === false) {
      router.push({
        path: "/authentication/otp",
        query: { phone: phone.value },
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error.message || "Invalid phone number or password. Please try again.",
        confirmButtonColor: "#d33",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  } finally {
    loading.value = false;
  }
};

const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

// onMounted(() => {
//   isDarkTheme.value = document.body.classList.contains('dark-theme')
// })
</script>

<style scoped>
.form-container {
  max-width: 400px;
  width: 100%;
  border-radius: 12px;
}

.image-container {
  position: relative;
  height: 100%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 100px;
}

.overlay {
  position: relative;
  text-align: center;
}

.login-image {
  max-width: 300px;
  border-radius: 8px;
}
</style>
